import openMap from './openMap';
import { mapState } from 'vuex';
export default {
  name: 'openlayers',
  components: {
    openMap
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      tagShow: state => state.setting.tagShow
    })
  }
};